<template>
  <div class="custom-select" ref="select">
    <div class="selected-option" @click="isOpen = !isOpen">
      <span
        style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          "
      >
        <span style="display: flex; flex-direction: column">
          <span class="custom-label">{{ label }} </span>
          <span class="select-text">
            {{ currentYearDisplay }}
          </span>
        </span>
      </span>
      <!--Dropdown icon-->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-caret-down-fill"
        viewBox="0 0 16 16"
      >
        <path d="M3.204 5h9.592L8 10.481 3.204 5z" />
      </svg>
    </div>
    <div class="options" v-show="isOpen">
      <div
        class="option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option, index)"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomFilterSelectYearsV2",
  data() {
    return {
      isOpen: false,
      selectedOption: this.value || this.currentYear,
      selectedIndex: null,
      currentYearDisplay: this.currentYear
    };
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    currentYear: {
      type: Number,
      default: () => new Date().getFullYear()
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: null
  },
  methods: {
    selectOption(option, index) {
      this.selectedOption = option;
      this.selectedIndex = index;
      this.currentYearDisplay = option;  // Update the displayed year
      this.isOpen = false;
      this.$emit("input", option);
    },
    handleClickOutside(event) {
      if (!this.$refs.select.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  watch: {
    value: function(val) {
      // Update both the selected option and displayed year when value changes
      this.selectedOption = val;
      this.currentYearDisplay = val;
    },
    currentYear: function(val) {
      // Ensure display updates if currentYear prop changes
      this.currentYearDisplay = val;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    // Initialize display with current year
    this.currentYearDisplay = this.currentYear;
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.custom-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/2 */

  color: #5b626f;
}
.select-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/default */

  color: #30384a;
}
.custom-select {
  position: relative;
  background-color: #f6f6f4;
  height: 64px;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
}
.selected-option {
  background-color: #f6f6f4;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  cursor: pointer;
}
.options {
  position: absolute;
  max-height: 400px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05),
    0px 4px 4px -1px rgba(0, 0, 0, 0.05), 0px 12px 16px -8px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

.options::-webkit-scrollbar {
  display: none;
}
.option {
  padding: 6px;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
}
.option:hover {
  background: #f2f3f4;
}
</style>
